/*
 * NotFoundPage Messages
 *
 * This contains all the text for the NotFoundPage container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.containers.NotFoundPage';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "Sorry, we couldn't find the page you're looking for!",
  },
  copy: {
    id: `${scope}.copy`,
    defaultMessage: 'Please check the url and try again or',
  },
  button: {
    id: `${scope}.button`,
    defaultMessage: 'Start a new search',
  },
});
